import React, { useEffect, useState } from "react";
import { Card } from "react-bootstrap";
import { db } from "../../firebase";
import EventsCardSubBody from "./EventsCardSubBody";
import ViewEventModal from "../EventsComp/ViewEventModal";

const getEventInfo = async (eventId) => {
  const eventsRef = db.collection("events");

  const eventInfo = await eventsRef.doc(eventId).get();
  return { ...eventInfo.data(), id: eventId };
};

const InterestedEventsCard = ({ data }) => {
  const [viewModalContent, setViewModalContent] = useState();

  const [showViewEventModal, setViewEventModal] = useState(false);
  const handleViewClose = () => setViewEventModal(false);
  const handleViewShow = () => setViewEventModal(true);

  const triggerViewPopup = (data, id) => {
    handleViewShow();
    setViewModalContent({ ...data, id });
  };

  const { maybe } = data;
  const [maybeEventInfoList, setMaybeEventInfoList] = useState([]);

  useEffect(() => {
    if (maybe) {
      maybe.forEach((eventId) => {
        getEventInfo(eventId).then((response) => {
          // console.log(response);
          setMaybeEventInfoList((prevValue) => {
            return [...prevValue, response];
          });
        });
      });
    }

    return () => {
      setMaybeEventInfoList([]);
    };
  }, []);
  // We need to fetch the event info based on the event ID
  return (
    <>
      <Card className="mt-3">
        <Card.Header>Events you're interested in</Card.Header>
        <Card.Body>
          {maybeEventInfoList ? (
            maybeEventInfoList.length > 0 ? (
              maybeEventInfoList.map((event) => {
                // console.log(event.id);

                return (
                  <EventsCardSubBody
                    triggerViewPopup={triggerViewPopup}
                    key={event.id}
                    data={event}
                  />
                );
              })
            ) : (
              <div className="text-center">
                <p>You have not indicated interest for any event yet</p>
              </div>
            )
          ) : null}
        </Card.Body>
      </Card>

      <ViewEventModal
        data={viewModalContent}
        show={showViewEventModal}
        handleClose={handleViewClose}
      />
    </>
  );
};

export default InterestedEventsCard;
